<template></template>
<script>
///////////////////////////////////////////////////////////////////////////////
// пришлось создать данный компонент, так как vue-router не умеет
// делать синхронный redirect
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	name: 'filterUser',
	//=========================================================================
	data() {
		return {
			userId: null,
			accountId: null
		}
	},
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// если это не сотрудник - редирект на страницу ошибки
		if (this.$store.state.user_type !== 'admin')
			return this.$router.push('/404')

		// получим параметр - ID пользователя, по аккаунту которого, нужен фильтр
		if (this.$route && this.$route.params && this.$route.params.id)
			this.userId = this.$route.params.id

		// если не указан ID пользователя - просто редирект на ошибку
		if (!this.userId) return this.$router.push('/404')

		// делаем запрос данных пользователя
		this.getUserAccount()
			.then(this.setAccountFilter, this.errorHandler)
			.then(
				// все прошло успено - редирект на страницу пользователя
				() => { this.$router.push('/user/view/' + this.userId) },
				// ошибке
				this.errorHandler
			)
	},
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		getUserAccount() {
			// все делаем на промисах
			return new Promise((resolve, reject) => {
				// мы должны запросить данные по пользователю
				let _url = this.APIServerUrl + '/user/view/' + this.userId
				// сам запрос
				this.$http.get(_url).then(
					// если мы успешно получили словарь
					resGet => {
						// получаем ответ
						if (resGet && typeof resGet === 'object' && resGet['status'] === 200 && resGet['body'] &&
							resGet['body']['status'] === 'ok' &&
							resGet['body']['account'] && resGet['body']['account']['account_id'] && resGet['body']['account']['account_id']['value'])
						{
							this.accountId = resGet['body']['account']['account_id']['value']
							resolve()
						}
						else reject('error/api_incorrect')
					},
					// возникла какая то ошибка
					resGet => {
						reject('error/api_incorrect')
					}
				)
			})
		},
		//---------------------------------------------------------------------
		setAccountFilter() {
			// все делаем на промисах
			return new Promise((resolve, reject) => {
				// ID аккаунта получен - ставим фильтр
				let _accountID = parseInt(this.accountId)
				if (isNaN(_accountID) || _accountID < 1) return reject('main/data_not_found')

				// начинаем установку фильтра - готовим параметры и URL
				let _url = this.APIServerUrl + '/admin/index'
				let _params = {
					'additional': 'addGlobalFilter',
					'type': 'account',
					'object_id': _accountID
				}

				// обнуляем флаг в Vuex о наличии глобального фильтра
				this.$store.commit('accountGlobalFilter', false)

				// делаем сам запрос
				this.$http.get(_url, { 'params': _params }).then(
					// получили успешный ответ сервера
					resGet => {
						let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
						if (_dt && _dt['status'] === 'ok')
						{
							// стафим флаг в Vuex о наличии глобального фильтра
							this.$store.commit('accountGlobalFilter', true)

							// запрос счетчиков
							this.$store.dispatch('getTicketCounters')
							this.$store.dispatch('getRequestCounter')

							return resolve()
						}

						reject('error/api_incorrect')
					},
					// получили отрицательный ответ сервера
					resGet => {
						reject('error/api_incorrect')
					}
				)
			})
		},
		//---------------------------------------------------------------------
		errorHandler() {
			this.$router.push('/404')
		}
		//---------------------------------------------------------------------
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// filterUser.vue?00dc1d2a